import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { productsListSelector } from 'selectors';
import { getTrendingProds, lastPriceChangeSelector } from 'selectors/tickerSelectors';
import { useAppSelector } from 'storeHooks';
import { FireIcon } from 'styles/assets/icons';
import { Product } from 'types/IProducts';

import styles from '../universal-search.module.scss';
import { getMixpanelPageName } from './helpers';
import { TrendingContractsProps } from './interface';
import SearchResult from './searchResult';

const TrendingContracts = (props: TrendingContractsProps) => {
  const { onRowClick } = props;
  const productsList = useAppSelector(state => productsListSelector(state));
  const { t } = useTranslation(['headerFooter']);

  const trendingProds = useMemo(() => {
    const trendingContracts = getTrendingProds(productsList).filter(product =>
      IS_INDIAN_EXCHANGE
        ? !['BTCUSD', 'ETHUSD'].includes(product.symbol)
        : !['BTCUSDT', 'ETHUSDT'].includes(product.symbol)
    );

    const fixedProducts = productsList
      .filter(product =>
        (IS_INDIAN_EXCHANGE ? ['BTCUSD', 'ETHUSD'] : ['BTCUSDT', 'ETHUSDT']).includes(
          product?.symbol
        )
      )
      .sort(prod =>
        prod?.symbol === (IS_INDIAN_EXCHANGE ? 'BTCUSD' : 'BTCUSDT') ? -1 : 0
      );

    // Take only 4 additional contracts
    const additionalContracts = trendingContracts.slice(0, 4);

    const updatedContracts = trendingContracts.length
      ? [...fixedProducts, ...additionalContracts]
      : [];

    return updatedContracts;
  }, [productsList]);

  const onTrendingContractClicked = (product: Product) => {
    onRowClick(product);
    trackMixpanelEvent('Search- Trending Contract Clicked', {
      source: getMixpanelPageName(),
      contract_name: product.symbol,
    });
  };

  return (
    (<div
      className={styles['trending-products-container']}
      data-palette="TrendingContracts">
      <div className={styles.header}>
        {t('headerFooter:header.trending')}
        <FireIcon />
      </div>
      <div className={styles.content}>
        {trendingProds.map(product => {
          const change24h: any = Number(lastPriceChangeSelector(product));
          const { symbol, id, contract_type: contractType } = product;
          return (
            <SearchResult
              key={id}
              productId={id}
              symbol={symbol}
              contractType={contractType}
              changeIn24h={change24h}
              onRowClick={() => onTrendingContractClicked(product)}
            />
          );
        })}
      </div>
    </div>)
  );
};

export default TrendingContracts;
